/* globals CountdownTimer */

'use strict';

module.exports = () => {
  const el = document.querySelector(
    '#urgency-messaging-timer .countdown-timer'
  );
  if (
    !el ||
    !window.payload.urgencyMessagingV2 ||
    !window.payload.urgencyMessagingV2.timer
  ) {
    return;
  }

  const timer = window.payload.urgencyMessagingV2.timer;
  // init the timer
  timer.el = '#urgency-messaging-timer .countdown-timer';
  timer.isTouchRequest = false;
  timer.translationScope = 'js.modules.groupon-deal-timer.tile';

  CountdownTimer.init({ timerData: timer });
};
